import { Helper } from '../utils/Helper';

export class HistoryManager {
	private container: Phaser.GameObjects.Container;
	private scene: Phaser.Scene;
	private blacks: number[];
	private reds: number[];
	private history: { value: number; image: Phaser.GameObjects.Image; text: Phaser.GameObjects.Text }[];
	private hiddenStack: Phaser.GameObjects.Image[];
	private background: Phaser.GameObjects.Image;
	private title: Phaser.GameObjects.BitmapText;
	private slotSpacing: number;
	private maxSlots: number;
	private helper!: Helper;
	private maskShape!: Phaser.GameObjects.Graphics;
	private mask!: Phaser.Display.Masks.GeometryMask;
	private backgroundShadown: Phaser.GameObjects.Sprite;

	constructor(scene: Phaser.Scene, container: Phaser.GameObjects.Container, blacks: number[], reds: number[]) {
		this.scene = scene;
		this.blacks = blacks;
		this.reds = reds;
		this.history = []; // Histórico visível
		this.hiddenStack = []; // Histórico oculto
		this.slotSpacing = 44; // Espaço entre os itens na pilha
		this.maxSlots = 5; // Quantidade máxima de itens visíveis
		this.helper = new Helper(this.scene);

		// Cria o container vazio
		this.container = container;
		this.container.setDepth(10);

		// Cria a borda do container
		this.background = this.helper.addSpriteLocPos('bucket', -430, -400).setScale(0.4).setName('bucket').setDepth(1);
		const backgroundOutSide = this.helper
			.addSpriteLocPos('bucket', -423, -393)
			.setScale(0.4)
			.setName('bucketOutSide')
			.setAlpha(0.2)
			.setTint(0x000000)
			.setDepth(1);
		this.backgroundShadown = this.helper
			.addSpriteLocPos('bucketShadown', -430, -400)
			.setScale(0.4)
			.setName('bucketShadown')
			.setAlpha(0.2)
			.setTint(0x000000)
			.setDepth(5);

		// Cria o título
		this.title = this.helper.addBitmapText('HISTORY', 'gameFont_0', 20, 1, -450, -450).setDepth(6);

		// Adiciona a borda e o título ao container
		this.container.add([backgroundOutSide, this.background, this.backgroundShadown, this.title]);

		// Garante que o `backgroundShadown` esteja sempre na frente
		this.container.moveTo(this.backgroundShadown, this.container.length - 1);
	}

	addNumber(value: number): void {
		this.animateBall(value);
	}

	private animateBall(value: number): void {
		let textureKey = 'greenBall';
		if (this.blacks.includes(value)) textureKey = 'blackBall';
		if (this.reds.includes(value)) textureKey = 'redBall';

		// Cria a imagem (bola)
		const ball = this.scene.add.image(0, 61, textureKey).setScale(0.6).setDepth(2);
		this.container.add(ball);

		const newText = value < 10 && value !== 0 ? '0' + value : value;

		// Cria o texto centralizado na bola
		const text = this.scene.add
			.text(0, 60, newText.toString(), {
				fontFamily: 'Arial',
				fontSize: '20px',
				color: '#ffffff',
				align: 'center',
				fontStyle: 'bold'
			})
			.setOrigin(0.5, 0.5);
		this.container.add(text);

		const targetImage = this.container.getByName('bucket') as Phaser.GameObjects.Image;
		const worldMatrix = targetImage.getWorldTransformMatrix();
		const globalX = worldMatrix.tx;
		const globalY = worldMatrix.ty;
		const bucketWidth = targetImage.displayWidth - 10;
		const bucketHeight = targetImage.displayHeight - 10;

		// MASCARA ----------------------------------------
		const maskShape = this.scene.add.graphics();
		maskShape.fillStyle(0xffffff);
		maskShape.fillRoundedRect(globalX - bucketWidth / 2, globalY - bucketHeight / 2, bucketWidth, bucketHeight, 20);
		const mask = maskShape.createGeometryMask();
		ball.setMask(mask);
		text.setMask(mask);

		// Adiciona o novo item no início da lista
		this.history.unshift({ value, image: ball, text });

		// Reposiciona os itens visíveis
		this.history.forEach((item, index) => {
			const targetX = 180 + index * this.slotSpacing;

			this.scene.tweens.add({
				targets: [item.image, item.text],
				x: targetX,
				duration: 300,
				ease: 'Power2'
			});

			// Agora, vamos garantir que apenas os primeiros `maxSlots` sejam visíveis
			if (index >= this.maxSlots) {
				item.image.setAlpha(0); // Torna invisível
				item.text.setAlpha(0); // Torna o texto invisível
			} else {
				item.image.setAlpha(1); // Deixa visível
				item.text.setAlpha(1); // Deixa o texto visível
			}
		});

		// Garante que o `backgroundShadown` esteja sempre na frente
		this.container.moveTo(this.backgroundShadown, this.container.length - 1);
	}

	getContainer(): Phaser.GameObjects.Container {
		return this.container;
	}
}
